import React from 'react'
import { useTranslation } from 'react-i18next'

interface ISuggestedTime {
  date: string
  time: string
  dateTime: Date
}

interface ISuggestedTimesProps {
  suggestedTimes: ISuggestedTime[]
  isLoading: boolean
  onTimeSelect: (suggestion: ISuggestedTime) => void
}

export const SuggestedTimes: React.FC<ISuggestedTimesProps> = ({
  suggestedTimes,
  isLoading,
  onTimeSelect,
}) => {
  const { t } = useTranslation()
  return (
    <div className="mb-5">
      <label className="block text-sm font-medium text-app-grey-60 mb-3">
        {t('calendar.suggestedTimes.heading')}
      </label>
      {isLoading ? (
        <div className="flex items-center justify-center py-4">
          <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-primary"></div>
          <span className="ml-2 text-sm text-primary-text">
            {t('calendar.suggestedTimes.finding')}
          </span>
        </div>
      ) : suggestedTimes.length > 0 ? (
        <div className="space-y-2">
          {suggestedTimes.map((suggestion, index) => (
            <button
              key={index}
              onClick={() => onTimeSelect(suggestion)}
              className="w-full flex items-center justify-between px-3 py-2 bg-white hover:bg-primary-brandLight border border-app-grey-30 border-glow-focus rounded-lg transition-colors text-left"
            >
              <div className="flex items-center gap-2">
                <span className="text-sm font-medium text-primary-text">{suggestion.date}</span>
                <span className="text-sm font-light text-primary-disabledTextLight">
                  {suggestion.time}
                </span>
                <span className="w-2 h-2 rounded-full bg-green-online"></span>
              </div>
              <span className="text-sm font-medium text-green-online">
                {t('calendar.suggestedTimes.allFree')}
              </span>
            </button>
          ))}
        </div>
      ) : (
        <div className="flex items-center justify-center py-4">
          <span className="text-sm text-silver-light">{t('calendar.suggestedTimes.none')}</span>
        </div>
      )}
    </div>
  )
}
